import axios from 'axios';
import { createSignedGetRequest } from 'utils/createSignedRequestsHelpers';

export const getAdminInitialDataByProjectsOfBusinessInTimeFrame = async (
  projectId,
  fromDate,
  toDate,
  activeEmployerInfo
) => {
  const apiPath = `workflow/init/admin-request/by-projects-of-business/${projectId}/${fromDate}/${toDate}`;

  const signedRequest = await createSignedGetRequest({
    apiPath,
    activeEmployerInfo,
  });

  const response = await axios(signedRequest);

  return response.data;
};
